import Axios from "../../configs/axios.config";

export const attemptLogin = (data) => Axios.post(`/auth/login`, data);
export const getInitialData = (data) => Axios.get(`/common/initial`);
export const switchWorkspace = (data) => Axios.post(`/workspaces/switch-workspace`, data);
export const getPermissions = () => Axios.get(`/common/permissions/permission`);
export const logoutUser = (data) => Axios.post(`/auth/logout`, data);